"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse = function (a) {
    a = a.toString();
    var value = parseFloat(a);
    var unit = a.replace(value, '');
    return { value: value, unit: unit };
};
var validate = function (a, b) {
    var unitA = parse(a).unit;
    var unitB = parse(b).unit;
    if (unitA && unitB && unitA !== unitB) {
        console.log('Invalid operation, units should be the same');
        return false;
    }
    return true;
};
var add = function (a, b) {
    if (!validate(a, b)) {
        return;
    }
    var unit = parse(a).unit;
    var value = parse(a).value + parse(b).value;
    return value + unit;
};
exports.add = add;
var subtract = function (a, b) {
    if (!validate(a, b)) {
        return;
    }
    var unit = parse(a).unit;
    var value = parse(a).value - parse(b).value;
    return value + unit;
};
exports.subtract = subtract;
var multiply = function (a, b) {
    if (!validate(a, b)) {
        return;
    }
    var unit = parse(a).unit;
    var value = parse(a).value * parse(b).value;
    return value + unit;
};
exports.multiply = multiply;
//# sourceMappingURL=pixel-calc.js.map